// Autocorrelation-based pitch detection (similar to the
// implementation popularised by Chris Wilson). Operates on a single
// time-domain buffer and returns a frequency estimate in Hz, or -1
// if no clear pitch is found.

export function autoCorrelate(buf, sampleRate) {
    const SIZE = buf.length;
    let rms = 0;
    for (let i = 0; i < SIZE; i++) rms += buf[i] * buf[i];
    rms = Math.sqrt(rms / SIZE);
    if (rms < 0.01) return -1; // too quiet

    // Trim silence
    let r1 = 0;
    let r2 = SIZE - 1;
    const thres = 0.2;
    for (let i = 0; i < SIZE / 2; i++) {
        if (Math.abs(buf[i]) < thres) {
            r1 = i;
            break;
        }
    }
    for (let i = 1; i < SIZE / 2; i++) {
        if (Math.abs(buf[SIZE - i]) < thres) {
            r2 = SIZE - i;
            break;
        }
    }
    const trimmed = buf.subarray(r1, r2);
    const N = trimmed.length;
    if (N < 2) return -1;

    const c = new Array(N).fill(0);
    for (let i = 0; i < N; i++) {
        for (let j = 0; j < N - i; j++) {
            c[i] += trimmed[j] * trimmed[j + i];
        }
    }
    let d = 0;
    while (d < N - 1 && c[d] > c[d + 1]) d++;
    let maxval = -1;
    let maxpos = -1;
    for (let i = d; i < N; i++) {
        if (c[i] > maxval) {
            maxval = c[i];
            maxpos = i;
        }
    }
    let T0 = maxpos;
    if (T0 <= 0) return -1;

    // Parabolic interpolation around the peak
    const x1 = c[T0 - 1] || 0;
    const x2 = c[T0];
    const x3 = c[T0 + 1] || 0;
    const a = (x1 + x3 - 2 * x2) / 2;
    const b = (x3 - x1) / 2;
    if (a) T0 = T0 - b / (2 * a);

    const freq = sampleRate / T0;
    if (freq < 50 || freq > 2000) return -1;
    return freq;
}
